// extracted by mini-css-extract-plugin
module.exports = {"container":"DividerWithText_container__1_78b","border":"DividerWithText_border__3BrQR"};